exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".coming-1{fill:#f4f8fa}.coming-2{fill:#fff}.coming-3{fill:none}.coming-4{fill:#fbe57f}.coming-5{fill:#1e4e69}\n", ""]);
